var React = require('react');

function More (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.0909 12.186L8.0483 16.2125C7.95769 16.2579 7.84577 16.1996 7.84577 16.1071V8.05384C7.84577 7.96146 7.95769 7.90304 8.0483 7.94844L16.0909 11.9751C16.1834 12.0213 16.1834 12.1398 16.0909 12.186ZM16.1542 7.921V0.500004H7.84577V7.921H0V16.2293H7.84577V23.8656H16.1542V16.2293H24V7.921H16.1542Z","fill":"currentColor"}));
}

More.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = More;

More.default = More;
